<dx-select-box #selectBox
               displayExpr="name"
               valueExpr="id"
               [dataSource]="executionModes"
               [disabled]="loading"
               [readOnly]="readOnly"
               [value]="selectedItem"
               (selectedItemChange)="onSelectedItemChange($event)">
</dx-select-box>
